var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import ApiService from "../core/services/ApiService";
// 푸시 토큰 저장 키
var PUSH_DATA_KEY = 'appPushData';
// LocalStorage에 저장
var savePushData = function (partialData) {
    var existing = JSON.parse(localStorage.getItem(PUSH_DATA_KEY) || '{}');
    var updated = __assign(__assign({}, existing), partialData);
    localStorage.setItem(PUSH_DATA_KEY, JSON.stringify(updated));
};
// LocalStorage에서 읽기
var getPushData = function () {
    return JSON.parse(localStorage.getItem(PUSH_DATA_KEY) || '{}');
};
function registerPushToken() {
    var _a, _b, _c;
    return __awaiter(this, void 0, void 0, function () {
        var _d, token, uuid, version, error_1;
        return __generator(this, function (_e) {
            switch (_e.label) {
                case 0:
                    _d = getPushData(), token = _d.token, uuid = _d.uuid, version = _d.version;
                    if (!token || !uuid) {
                        console.log('푸시 토큰 또는 UUID가 없습니다. 등록을 건너뜁니다.');
                        return [2 /*return*/];
                    }
                    else {
                        console.log('푸시 토큰과 UUID가 있습니다. 등록을 진행합니다. 버전: ' + version + ', UUID: ' + uuid + ', 토큰: ' + token);
                    }
                    _e.label = 1;
                case 1:
                    _e.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, ApiService.post("".concat(process.env.MIX_API_HOST, "/push-token"), {
                            push_token: token,
                            device_uuid: uuid,
                            platform: ((_b = (_a = window.isMobile) === null || _a === void 0 ? void 0 : _a.Android) === null || _b === void 0 ? void 0 : _b.call(_a)) ? 'android' : 'ios',
                            app_version: version,
                            user_agent: navigator.userAgent,
                        })];
                case 2:
                    _e.sent();
                    console.log('푸시 토큰 등록 성공');
                    // 등록 후 localStorage 초기화
                    localStorage.removeItem(PUSH_DATA_KEY);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _e.sent();
                    if (ApiService.axiosInstance.isAxiosError(error_1)) {
                        console.error('푸시 토큰 등록 실패:', (_c = error_1.response) === null || _c === void 0 ? void 0 : _c.data);
                        // alert('푸시 토큰 등록 실패:' + (error.response?.data?.message || '알 수 없는 오류'));
                    }
                    else {
                        console.error('알 수 없는 오류:', error_1);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    });
}
export { registerPushToken, savePushData, getPushData, };
